import { IMMERSIVE_VIEWER_MOBILE_MAX } from "./immersive-viewer-layout";

/** Tailwind `lg`. Phone + tablet use the drawer; hover rail starts here. */
export const DASHBOARD_DESKTOP_NAV_MIN = 1024;

export const dashboardDesktopNavMin = (immersiveViewerOpen) =>
  immersiveViewerOpen ? IMMERSIVE_VIEWER_MOBILE_MAX + 1 : DASHBOARD_DESKTOP_NAV_MIN;

/** Hide hamburger / mobile drawer once the desktop rail is shown. */
export const dashboardMobileChromeClass = (immersiveViewerOpen) =>
  immersiveViewerOpen ? "xl:hidden" : "lg:hidden";

export const dashboardDesktopRailClass = (immersiveViewerOpen) =>
  immersiveViewerOpen
    ? "hidden xl:fixed xl:left-0 xl:top-16 xl:bottom-0 xl:flex xl:flex-col transition-all duration-300 z-50"
    : "hidden lg:fixed lg:left-0 lg:top-16 lg:bottom-0 lg:flex lg:flex-col transition-all duration-300 z-50";

export const dashboardLogoVisibilityClass = (immersiveViewerOpen) =>
  immersiveViewerOpen ? "hidden xl:flex" : "hidden sm:flex";

export const topBarUserInitials = (user) => {
  const raw = user?.name || user?.displayTitle || user?.email || "";
  const text = String(raw).trim();
  if (!text) return "?";
  const local = text.includes("@") ? text.split("@")[0] : text;
  const parts = local.split(/[\s._-]+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[parts.length - 1][0] || ""}`.toUpperCase();
};
